<template>
  <div :class="[`view-501-item-1 poppins-bold-black-15px`, className || ``]">
    <div class="number-11">{{ number }}</div>
    <div class="group-234-18" :style="{ 'background-image': 'url(' + group234 + ')' }"></div>
    <div class="text-497">{{ text520 }}</div>
    <div class="text-496">{{ text519 }}</div>
  </div>
</template>

<script>
export default {
  name: "X362",
  props: ["number", "group234", "text520", "text519", "className"],
};
</script>

<style>
.view-501-item-1 {
  display: flex;
  margin-left: 36px;
  margin-top: 2.5px;
  width: 346px;
}

.number-11 {
  height: 23px;
  letter-spacing: 0.3px;
  line-height: normal;
  margin-top: 18px;
  width: 10px;
}

.group-234-18 {
  aspect-ratio: 1;
  background-color: var(--alto);
  background-position: 50% 50%;
  background-size: cover;
  border-radius: 60px;
  height: 55px;
  margin-left: 14px;
  width: 55px;
}

.text-497 {
  height: 23px;
  letter-spacing: 0.3px;
  line-height: normal;
  margin-left: 6px;
  margin-top: 18px;
  width: 152px;
}

.text-496 {
  height: 23px;
  letter-spacing: 0.3px;
  line-height: normal;
  margin-left: 69px;
  margin-top: 18px;
  width: 34px;
}

.view-501-item-1.view-501-item .number-11,
.view-501-item-1.view-504-item .number-11,
.view-501-item-1.view-item-3 .number-11,
.view-501-item-1.view-item-4 .number-11,
.view-501-item-1.view-item-5 .number-11,
.view-501-item-1.view-item-6 .number-11 {
  width: 11px;
}

.view-501-item-1.view-501-item .group-234-18,
.view-501-item-1.view-504-item .group-234-18,
.view-501-item-1.view-item-3 .group-234-18,
.view-501-item-1.view-item-4 .group-234-18,
.view-501-item-1.view-item-5 .group-234-18,
.view-501-item-1.view-item-6 .group-234-18 {
  margin-left: 13px;
}

.view-501-item-1.view-501-item .text-497,
.view-501-item-1.view-504-item .text-497,
.view-501-item-1.view-item-3 .text-497,
.view-501-item-1.view-item-4 .text-497,
.view-501-item-1.view-item-5 .text-497,
.view-501-item-1.view-item-6 .text-497 {
  width: 125px;
}

.view-501-item-1.view-501-item .text-496,
.view-501-item-1.view-504-item .text-496,
.view-501-item-1.view-item-3 .text-496,
.view-501-item-1.view-item-4 .text-496,
.view-501-item-1.view-item-5 .text-496,
.view-501-item-1.view-item-6 .text-496 {
  margin-left: 96px;
}

.view-501-item-1.x5-3,
.view-501-item-1.x5-4 {
  display: flex;
  margin-left: 36px;
  margin-top: 2px;
  width: 346px;
}

.view-501-item-1.x5-3 .text-497,
.view-501-item-1.x5-4 .text-497,
.view-501-item-1.x5-5 .text-497,
.view-501-item-1.x5-6 .text-497,
.view-501-item-1.x5-7 .text-497,
.view-501-item-1.x5-8 .text-497 {
  width: 133px;
}

.view-501-item-1.x5-3 .text-496,
.view-501-item-1.x5-4 .text-496,
.view-501-item-1.x5-5 .text-496,
.view-501-item-1.x5-6 .text-496,
.view-501-item-1.x5-7 .text-496,
.view-501-item-1.x5-8 .text-496 {
  margin-left: 88px;
}

.view-501-item-1.view-item-3,
.view-501-item-1.view-item-3-1,
.view-501-item-1.view-item-4,
.view-501-item-1.view-item-4-1,
.view-501-item-1.view-item-5,
.view-501-item-1.view-item-5-1,
.view-501-item-1.view-item-6,
.view-501-item-1.view-item-6-1 {
  margin-left: 26px;
}

.view-501-item-1.x5-5,
.view-501-item-1.x5-6,
.view-501-item-1.x5-7,
.view-501-item-1.x5-8 {
  display: flex;
  margin-left: 26px;
  margin-top: 2px;
  width: 346px;
}
</style>
